import { render, staticRenderFns } from "./OfflinePaymentDetail.html?vue&type=template&id=bdf5c5ec&scoped=true&"
import script from "./OfflinePaymentDetail.js?vue&type=script&lang=js&"
export * from "./OfflinePaymentDetail.js?vue&type=script&lang=js&"
import style0 from "./OfflinePaymentDetail.scss?vue&type=style&index=0&id=bdf5c5ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdf5c5ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VImg,VRow})
